import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { authProvider } from './AzureADConfig';
import AppWithAuthentication from './AppWithAuthentication';

import './index.scss';
import ErrorBoundary from './components/errors/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
	<React.StrictMode>
		<ErrorBoundary>
			<MsalProvider instance={authProvider}>
				<AppWithAuthentication />
			</MsalProvider>
		</ErrorBoundary>
	</React.StrictMode>
);

reportWebVitals();
